import { createApp } from 'vue'
import NykCard from './NykCard.vue'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps'

const el = '.nyk-component--nyk-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((nykCardDOM) => {
            const props = handleComponentProps(NykCard, nykCardDOM) || {}
            const component = createApp(NykCard, props).use(Store)
            component.mount(nykCardDOM)
        })
    }
}
